(function () {
  'use strict';
  function renderDistances() {
    document.querySelectorAll('[data-gen-country-warehouse-distance]').forEach(function (element) {
      var keys = ['cityLatitude', 'cityLongitude', 'warehouseLatitude', 'warehouseLongitude'];
      var coordinates = keys.map(function (key) {
        var value = element.dataset[key];
        return value && value.trim() ? Number(value) : NaN;
      });
      if (!coordinates.every(Number.isFinite)
        || Math.abs(coordinates[0]) > 90 || Math.abs(coordinates[2]) > 90
        || Math.abs(coordinates[1]) > 180 || Math.abs(coordinates[3]) > 180) return;
      var radians = function (value) { return value * Math.PI / 180; };
      var latitudeDelta = radians(coordinates[2] - coordinates[0]);
      var longitudeDelta = radians(coordinates[3] - coordinates[1]);
      var a = Math.sin(latitudeDelta / 2) * Math.sin(latitudeDelta / 2)
        + Math.cos(radians(coordinates[0])) * Math.cos(radians(coordinates[2]))
        * Math.sin(longitudeDelta / 2) * Math.sin(longitudeDelta / 2);
      a = Math.max(0, Math.min(1, a));
      var meters = 6371008.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var label = element.querySelector('[data-gen-country-distance-label]');
      var output = element.querySelector('[data-gen-country-distance-value]');
      if (!label || !output) return;
      output.textContent = '~' + (meters / 1000).toLocaleString('de-DE', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + ' km';
      label.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderDistances);
  else renderDistances();
}());
